import styled from "styled-components";

export const Container = styled.div`
  /* display: flex;
  gap: ${({ theme }) => theme.spacing * 4}px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing * 4}px;
    flex-direction: column;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    position: fixed;
    top: 16px;
    left: 16px;
    z-index: 2000;
  } */
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing * 4}px;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing * 4}px;
    background-color: ${({ theme }) => theme.colors.shades[0]};
    .category-container {
      width: calc(100vw - 32px);
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
`;

export const FiltersButton = styled.button`
  background-color: ${({ theme }) => theme.colors.shades[0]};
  color: ${({ theme }) => theme.colors.gray[900]};
  border: none;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing * 2}px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 4}px;
  border-radius: ${({ theme }) => theme.radius}px;
  justify-content: center;
  position: relative;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.gray[900]}
    }
  }
`;

export const ClearFiltersButton = styled(FiltersButton)`
  color: ${({ theme }) => theme.colors.primary[500]};
`;